export default __webpack_public_path__ + "static/media/projects-cards.7f3745b6.jpg";